/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { AwsEc2InstanceRestoreTarget } from '../models/AwsEc2InstanceRestoreTarget';

export class AwsEc2InstanceRestoreDestination {
  'awsEc2'?: AwsEc2InstanceRestoreTarget;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "awsEc2",
      "baseName": "awsEc2",
      "type": "AwsEc2InstanceRestoreTarget",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return AwsEc2InstanceRestoreDestination.attributeTypeMap;
  }

  public constructor() {
  }
}

